import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { useAuthStore } from '../../auth/stores/authStore';
import { api } from '../../../shared/api/billdaApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetUnapprovedAllocations() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.unapprovedAllocations(),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v1/dashboard/unapproved-allocations', {
          signal,
        })
      ),
    enabled: isAuthenticated,
    staleTime: 30_000,
  });
}
